import React from "react";
import "./VirasatV2InputComponents.scss"

const VirsatTextArea = ({ label, value, onChange, placeholder, required, error, errorText, disable }) => {


    return (
        <div className="VirasatV2InputComponents-VirasatV2Default">
            <div className="input-label">
                {label}
                {required && <span className="input-req">* </span>}
            </div>
            <div className={`VirasatV2InputComponents-VirasatV2Default-container ${error ? "error" : disable ? "disable" : ""}`}>
                <textarea
                    className="VirasatV2InputComponents-VirasatV2Default-container-textareanew"
                    value={value}
                    onChange={onChange}
                    type="text"
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default VirsatTextArea